import React from "react";
import ScheduleEntry from "./ScheduleEntry";
import Button from "./Button";

class InstructorDash extends React.Component {
  appointments = this.props.appointments[this.props.index];

  getAppointments = a => {
    return (
      <ScheduleEntry
        key={a}
        dataPass={this.appointments[a]}
        day={this.props.index}
        path="app/instructor-dashboard"
        buttonValue="More Info"
      />
    );
  };
  render() {
    return (
      // @TODO Add loop for Entries and remove static data.
      <div className="instructor-dash-wrapper">
        {Object.keys(this.appointments).map(this.getAppointments)}
        <Button
          path="app/instructor-dashboard"
          buttonValue="Back To Dashboard"
        />
      </div>
    );
  }
}

export default InstructorDash;
